var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-sidebar-recents" },
    [
      _c(
        "transition-group",
        {
          staticClass: "chat-sidebar-recents__lista",
          attrs: { tag: "div", name: "chat-sidebar-recents-linha" }
        },
        _vm._l(_vm.itens, function(item) {
          return _c("ConversationRow", {
            key: item.conversa.id,
            attrs: {
              conversation: item.conversa,
              selected: item.conversa.id === _vm.selectedId,
              folders: _vm.pastas,
              "rotulo-secundario": item.rotulo,
              "estilo-limpo": _vm.estiloLimpo,
              "permitir-selecao-lote": _vm.permitirSelecaoLote,
              "selected-for-batch": _vm.selecionadosEmLote.has(
                item.conversa.id
              ),
              "sem-acoes-de-pasta": ""
            },
            on: {
              select: function($event) {
                return _vm.$emit("select", $event)
              },
              rename: function($event) {
                return _vm.$emit("rename", $event)
              },
              "request-delete": function($event) {
                return _vm.$emit("request-delete", $event)
              },
              move: function($event) {
                return _vm.$emit("move", $event)
              },
              "toggle-select": function($event) {
                return _vm.$emit("toggle-select", $event)
              }
            }
          })
        }),
        1
      ),
      _vm.mostraVerTodas
        ? _c(
            "button",
            {
              staticClass: "chat-sidebar-recents__ver-todas ia-sidebar-aux",
              attrs: { type: "button" },
              on: { click: _vm.alternarVerTodas }
            },
            [_vm._v(" " + _vm._s(_vm.rotuloVerTodas) + " ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }